import accountApi from "@/api/account";
import { timeLoop } from "@/assets/js/util";
import pageCommon from "@/utils/pagecommon";
export default {
    data() {
        return {
            timerObj: {
                timer: null,
            },
            timeCount: 0,
            maxTime: 60,
            sendCodeText: "发送验证码",
            sendphoneValideForName: "",
            sendPhoneFormeDataName: "",
            valideFieldPhoneItemName: "user_phone"
        }
    },
    methods: {
        handleSendPhoneCode: function() {
            let _this = this;
            if (_this.timeCount > 0 || _this.isRequesting) {
                return;
            }
            _this.isRequesting = true;
            _this.validPhoneNumRight().then(
                () => {
                    if (!_this.sendPhoneFormeDataName || !_this[_this.sendPhoneFormeDataName] || !_this[_this.sendPhoneFormeDataName][_this.valideFieldPhoneItemName]) {
                        _this.$message.error("请填写手机号");
                        _this.isRequesting = false;
                        return;
                    }
                    console.log(_this[_this.sendPhoneFormeDataName])
                    console.log(_this[_this.sendPhoneFormeDataName][_this.valideFieldPicCode])
                    if (!_this.sendPhoneFormeDataName || !_this[_this.sendPhoneFormeDataName] || !_this[_this.sendPhoneFormeDataName][_this.valideFieldPicCode]) {
                        _this.$message.error("请填写图片验证码");
                        _this.isRequesting = false;
                        return;
                    }
                    let user_phone = _this[_this.sendPhoneFormeDataName][_this.valideFieldPhoneItemName];
                    let pic_code = _this[_this.sendPhoneFormeDataName][_this.valideFieldPicCode];
                    pageCommon.apiRequestCommon(accountApi, 'sendPhoneCode', { user_phone,pic_code, isloading: true }).then(res => {
                        _this.isRequesting = false;
                        if (_this.timerObj && _this.timerObj.timer) {
                            clearTimeout(_this.timerObj.timer);
                        }
                        // _this.timeCount=_this.maxTime;
                        timeLoop(_this.timerObj, _this.maxTime, function(count) {
                            _this.timeCount = count;
                            if (count <= 0) {
                                _this.sendCodeText = "发送验证码";
                            }
                            if (count > 0) {
                                _this.sendCodeText = `${count}s后可重发`;
                            }
                        });
                    }, err => {
                        if (err.sysUserLoginError) {
                            _this.isRequesting = false;
                            _this.$message.error("系统异常，请稍后刷新重试！");
                        } else {
                            _this.isRequesting = false;
                            _this.$message.error(err.data.msg);
                        }

                    })
                },
                (errValid) => {
                    _this.$message.error(errValid);
                    _this.isRequesting = false;
                }
            );
        },
        // 校验手机号是否正确
        validPhoneNumRight: function() {
            let _this = this;
            return new Promise((resolve, reject) => {
                let formRef = _this.sendphoneValideForName;
                _this.$refs[formRef].validateField(_this.valideFieldPhoneItemName, (valid) => {
                    if (!valid) {
                        resolve();
                        return;
                    }
                    reject(valid);
                });
            });
        },
    },
    filters: {

    },
    beforeDestroy() {

    }
}
